import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sgzp-app6.constants';

@Component({
  selector: 'app-sgzp-app6-change-password-sent',
  templateUrl: './sgzp-app6-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-app6-change-password-sent.component.css',
  ],
})
export class SgzpApp6ChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
